import { defineMessages } from "react-intl";

export const pagesListSearchAndFiltersMessages = defineMessages({
  searchPlaceholder: {
    id: "/x7Y7U",
    defaultMessage: "Search models",
    description: "search models placeholder",
  },
  publish: {
    id: "j/Oo0B",
    defaultMessage: "Publish",
    description: "bulk actions button label",
  },
  unpublish: {
    id: "ftOPoy",
    defaultMessage: "Unpublish",
    description: "bulk actions button label",
  },
  delete: {
    id: "CQKgD/",
    defaultMessage: "Delete model",
    description: "bulk actions button label",
  },
});
